// src/components/Button.jsx
import React from "react";

export function Button({ href, children }) {
  return (
    <a
      href={href}
      className="inline-block bg-primary text-white font-semibold uppercase px-6 py-3 rounded-full shadow-lg hover:bg-primary-dark transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
    >
      {children}
    </a>
  );
}
